import CoreComponent from '../../core/CoreComponent.vue';
import AccessibilityHelper from '../../../../helpers/accessibility-helper';
export default {
  extends: CoreComponent,
  mounted() {
    AccessibilityHelper.generateAriaLabelForBannerButton(this.cmpEl, ".cmp-sustainabilityBanner__title .cmp-sustainabilityBanner__title-text", ".cmp-sustainabilityBanner__action-container a");
  }
};